export function Tutorial() {
  return (
    <>
      <div className="tutorial-edit-name"/>
      <div className="tutorial-unlock-squirrels"/>
      <div className="tutorial-pet-squirrel"/>
      <div className="tutorial-bottom-toolbar"/>
    </>
  );
}